import script from "./AddNewCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewCourse.vue?vue&type=script&setup=true&lang=js"

import "./AddNewCourse.vue?vue&type=style&index=0&id=1b288a7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b288a7c"]])

export default __exports__